module.exports = __webpack_public_path__ + "static/buildings-c563d050274e06120dbd81749c574967.gif";